var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 180,
    height: 180,
    viewBox: "0 0 180 180",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 164.5V15L38 30V179.5L12 164.5Z",
    fill: "#DD9C80"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M38 0L12 15L38 30L64 15L38 0Z",
    fill: "#F0CFBF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M167.5 75.5L64 15L38 30L142.5 89.5L167.5 75.5Z",
    fill: "#8DDFD4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M142.5 119.5L38 179.5V59.5L65 75V135L142.5 89.5V119.5Z",
    fill: "#452E33"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M142.5 89.5L117 75L65 104.5V135L142.5 89.5Z",
    fill: "#F0CFBF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M167.5 105.5V75.5L142.5 89.5V119.5L167.5 105.5Z",
    fill: "#6AA8A0"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M38 30L117 75L90.5 90L38 59.5V30Z",
    fill: "#6AA8A0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.5ece4d4e81e3a3c1c17b3733c2551951.svg";
export { ForwardRef as ReactComponent };